import { useFormikContext } from 'formik';
import PropTypes from 'prop-types';
import React from 'react';
import { Button } from 'react-bootstrap';

import ManualPageTable from 'App/components/ManualPageTable';
import ActionCell from 'App/components/styles/ActionCell';
import hasLength from 'App/utils/hasLength';
import propOrDash from 'App/utils/propOrDash';

const AssignCell = ({ row }) => {
    const { values, setFieldValue } = useFormikContext();
    const hasGpi10 = !!row.original.gpi10;
    const isAssigned = values.gpi10 === row.original.gpi10;
    const isDisabled = !isAssigned && values.gpi10 !== '';

    return (
        <ActionCell>
            {hasGpi10 && (
                <Button
                    variant="link"
                    style={{ padding: 0 }}
                    onClick={() => setFieldValue('gpi10', isAssigned ? '' : row.original.gpi10)}
                    disabled={isDisabled}
                    data-testid={`edit-btn-${row.index}`}
                >
                    {isAssigned ? 'Unassign' : 'Assign'}
                </Button>
            )}
        </ActionCell>
    );
};

AssignCell.propTypes = {
    row: PropTypes.shape({
        original: PropTypes.shape({
            gpi10: PropTypes.string,
        }),
        index: PropTypes.number,
    }).isRequired,
};

const fixedColumns = [
    {
        Header: 'GPI_10',
        accessor: propOrDash('gpi10'),
        id: 'gpi10',
        canSort: true,
        style: { minWidth: '120px' },
    },
    {
        Header: 'Product Name',
        accessor: propOrDash('productName'),
        id: 'productName',
        canSort: true,
        style: { minWidth: '220px' },
    },
    {
        Header: 'Product Description',
        accessor: propOrDash('productDescription'),
        id: 'productDescription',
        canSort: true,
        style: { minWidth: '260px' },
    },
    {
        Header: 'CPS Generic Name',
        accessor: propOrDash('cpsGenericName'),
        id: 'cpsGenericName',
        canSort: true,
        style: { minWidth: '200px' },
    },
    {
        Header: 'Action',
        id: 'action',
        canSort: false,
        style: { minWidth: '120px' },
        Cell: AssignCell,
    },
];

const propTypes = {
    data: PropTypes.arrayOf(PropTypes.shape({})),
    totalRows: PropTypes.number.isRequired,
    onPageChange: PropTypes.func.isRequired,
    onSortChange: PropTypes.func.isRequired,
    currentPage: PropTypes.number,
    isSearching: PropTypes.bool,
};

const defaultProps = {
    data: [],
    currentPage: 1,
    isSearching: false,
};

const MedispanMedicationTable = ({ data, totalRows, onPageChange, onSortChange, currentPage, isSearching }) => {
    const canSort = !isSearching && hasLength(data);

    return (
        <ManualPageTable
            data={data}
            totalRows={totalRows}
            onPageChange={onPageChange}
            onSortChange={onSortChange}
            noRowsText="Search results based on the search criteria above will display here."
            initialSortKey="productName"
            initialSortOrder="asc"
            columns={fixedColumns}
            canSort={canSort}
            canPage={canSort}
            isLoading={isSearching}
            currentPage={currentPage}
        />
    );
};

MedispanMedicationTable.propTypes = propTypes;
MedispanMedicationTable.defaultProps = defaultProps;

export default MedispanMedicationTable;
